// Upload a File object to the chat-attachments bucket and return the public
// URL. Optimistically tracks progress in root.pendingAttachments[channelId]
// so the composer can render upload chips while the request is in flight.
//
// migrated 2026-04-27 to SDK route workspaceProject.storage upload + publicUrl.
// The workspace API wrapper at /workspace/storage/* enforces RLS server-side,
// so the browser never sees the bucket service-role key. Multipart upload
// uses the WorkspaceProjectService.storage.upload helper which composes a
// FormData request without forcing JSON Content-Type.
import { getSDK } from '../sdk.js'

const _slug = (s) => (s || '').toLowerCase().replace(/[^a-z0-9.-]/g, '-').slice(0, 80)

export const uploadAttachment = async function ({ channelId, file }) {
  if (!channelId || !file) return null
  const root = this.state.root
  const tempId = `att-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`
  const path = `${channelId}/${Date.now()}-${_slug(file.name)}`
  const placeholder = {
    id: tempId,
    name: file.name,
    size: file.size,
    mime: file.type,
    url: null,
    uploading: true
  }
  const cur = root.pendingAttachments[channelId] || []
  root.update({
    pendingAttachments: { ...root.pendingAttachments, [channelId]: [...cur, placeholder] }
  })

  try {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('path', path)
    formData.append('contentType', file.type || 'application/octet-stream')
    const result = await getSDK().execute('workspaceProject.storage', 'upload', {
      bucket: 'chat-attachments',
      formData,
      options: { cacheControl: '3600', upsert: false },
    })
    // Wrapper returns { url } (signed or public, depending on bucket config);
    // fall back to a publicUrl resolution if absent so the composer always
    // has something to render.
    const url = result?.url || result?.publicUrl ||
      (await getSDK().execute('workspaceProject.storage', 'publicUrl',
        { bucket: 'chat-attachments', path }))?.url ||
      null
    if (!url) throw new Error('upload returned no url')
    const next = (root.pendingAttachments[channelId] || []).map(a =>
      a.id === tempId ? { ...a, url, uploading: false } : a
    )
    root.update({ pendingAttachments: { ...root.pendingAttachments, [channelId]: next } })
    return url
  } catch (e) {
    console.error('[uploadAttachment]', e?.message || e)
    const next = (root.pendingAttachments[channelId] || []).filter(a => a.id !== tempId)
    root.update({ pendingAttachments: { ...root.pendingAttachments, [channelId]: next } })
    return null
  }
}

